import { memo } from 'react';
import { useGlobalLoading } from '@/contexts/GlobalLoadingContext';

/**
 * Global Loading Component
 * Renders the ContentLoader as an overlay inside the main container
 * Creates a semi-transparent backdrop with centered loading content
 */
function GlobalLoadingComponent() {
  const { isLoading, message } = useGlobalLoading();

  // Don't render anything if not loading
  if (!isLoading) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/20 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-xs mx-4 flex flex-col items-center space-y-6 border border-gray-100">
        {/* Modern Loading Spinner */}
        <div className="relative">
          <div className="w-12 h-12 border-3 border-gray-200 rounded-full" />
          <div
            className="absolute top-0 left-0 w-12 h-12 border-3 border-transparent border-t-blue-600 rounded-full animate-spin"
            style={{ animationDuration: '1s' }}
          />
        </div>

        {/* Clean Loading Message */}
        <div className="text-center space-y-2">
          <p className="font-semibold text-gray-800 text-base">
            {message}
          </p>
          <div className="flex items-center justify-center space-x-1">
            <div className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-pulse" style={{ animationDelay: '0ms' }}></div>
            <div className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-pulse" style={{ animationDelay: '200ms' }}></div>
            <div className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-pulse" style={{ animationDelay: '400ms' }}></div>
          </div>
        </div>
      </div>
    </div>
  );
}

/**
 * Memoized GlobalLoading component for optimal performance
 */
export const GlobalLoading = memo(GlobalLoadingComponent);